let $form = null;
let $buttons = null;
let clickCounter = 0;

const bindCtaEvents = attach => {

  // unbind the events
  if (!attach) {
    $buttons.off('click')
    clickCounter = 0
  }

  // bind the events
  $buttons.on('click', function(e) {
    e.stopImmediatePropagation();
    e.preventDefault();
    clickCounter += 1;
    return false;
  })

  $buttons.css({ opacity: '0.2' });
  clickCounter = 1;

}

const setSubmitHandler = () => {

  // extend the Umbraco unobtrusive form validator
  $form.data('validator').settings.submitHandler = form => {
    if (clickCounter) {
      return;
    }

    // run once ...
    bindCtaEvents(true);
    form.submit();
    bindCtaEvents(false);
  }
}

const init = () => {
  $(() => {
    $form = $(document.forms[0]);
    $buttons = $form.find('.ps-button');
    $form ? $form.data('validator') && setSubmitHandler() : null;
  });

};

const FormOnSubmitClickCatcher = { init };
export default FormOnSubmitClickCatcher;



// WEBPACK FOOTER //
// ./js/self-serve/core/FormOnSubmitClickCatcher.js